import { v4 as uuidv4 } from 'uuid';

export const storeSessionGroupId = (
    slug: string,
    restartGroupId?: string,
): string => {
    try {
        const newRestartGroupId = restartGroupId || uuidv4();
        localStorage.setItem(`survey_restart_group_${slug}`, newRestartGroupId);
        return newRestartGroupId;
    } catch (err) {
        console.error('Failed to store restartGroupId:', err);
        return '';
    }
};

export const getStoredSessionGroupId = (slug: string): string | null => {
    try {
        return localStorage.getItem(`survey_restart_group_${slug}`);
    } catch (err) {
        console.error('Failed to retrieve restartGroupId:', err);
        return null;
    }
};

export const deleteStoredSessionGroupId = (slug: string): void => {
    try {
        localStorage.removeItem(`survey_restart_group_${slug}`);
    } catch (err) {
        console.error('Failed to delete restartGroupId:', err);
    }
};
